'use client'

import { useEffect } from 'react'
import { initUserStore } from '@/store/user'

interface UserProviderProps {
    children: React.ReactNode
}

export function UserProvider({ children }: UserProviderProps) {
    // 在应用启动时初始化用户状态
    useEffect(() => {
        initUserStore()
    }, [])

    return <>{children}</>
}
